var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 39.3333L27.3333 34.6667V25.3333L35.3333 30V39.3333Z",
    fill: "#6042EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 44.6667L36.6667 40V30.6667L44.6667 35.3333V44.6667Z",
    fill: "#6042EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44.6667L54 40V30.6667L46 35.3333V44.6667Z",
    fill: "#4040B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 55.3333L36.6667 50.6667V41.3333L44.6667 46V55.3333Z",
    fill: "#6042EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/terraform.cb1e50212e79f9620798fc9bebbefb48.svg";
export { ForwardRef as ReactComponent };